export class RecipeTagWrapper {
  // true if use can acces basket preview form tags
  recipeDetailPreviewAllowed;

  constructor(recipeDetailPreviewAllowed = true) {
    this.recipeDetailPreviewAllowed = recipeDetailPreviewAllowed;
  }

  /**
   * @returns DomElement to watch
   */
   getTargetContainer(){
    throw new Error("You must implement 'getTargetContainer' for this retailer");
   }

  /**
   * @returns the placeholder for the recipe-tags
   */
  tagPlaceholders() {
    throw new Error("You must implement 'tagPlaceholders' for this retailer");
  }

  /**
   * @returns the item's extId to pass to the recipe-tags
   */
  itemExtId() {
    throw new Error("You must implement 'itemExtId' for this retailer");
  }
}
